import {httpInterceptor} from './interceptor';

export async function getAttendanceWindowGroups() {
  const response = await httpInterceptor.get('meetings/superadmin/attendance-groups');
  return response.data;
}

export async function getAttendanceWindows(group) {
  const response = await httpInterceptor.get('meetings/superadmin/attendance-windows', {
    params: {group, _t: Date.now()}
  });
  return response.data;
}

export async function updateAttendanceWindow(id, startedAt) {
  const response = await httpInterceptor.put(`meetings/superadmin/attendance-windows/${id}`, {startedAt});
  return response.data;
}
